import React, { Component } from 'react';
import {
    Button,
    Card,
    Col,
    DatePicker, Empty,
    Form, Icon,
    message,
    Row,
    Select,
    Skeleton,
    Spin,
    Table,
} from "antd";
import moment from "moment";
import {
    getAssetPurchaseReport,
} from "../../appRedux/actions/PurchaseOrder";
import { connect } from "react-redux";
// import './style.css';
import { fetchAssetFiltersData, searchGlobalAssetData } from "../../appRedux/actions";
import AssetSearch from "../../components/AssetSearch";
import { Link } from "react-router-dom";
import { saveAs } from 'file-saver';
import json2csv from 'json2csv';
import JSZip from 'jszip';
const { RangePicker } = DatePicker;

class AssetPurchaseReportComponent extends Component {

    state = {
        selectedAsset: null
    }

    componentDidMount() {
        this.props.fetchAssetFiltersData();
    }

    handleSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.form.validateFields((err, values) => {
            if (err) {
            } else {
                // console.log(values)
                if (moment(values.periodFromTo[0]).isSameOrBefore(values.periodFromTo[1])) {

                    const payload = {
                        asset: this.state.selectedAsset,
                        location: values.location,
                        subLocation: values.subLocation,
                        assetType: values.assetType,
                        assetSubType: values.assetSubType,
                        assetModel: values.assetModel,
                        // assetCategory: values.assetCategory,
                        periodFrom: moment(values.periodFromTo[0]).startOf('day').toDate(),
                        periodTo: moment(values.periodFromTo[1]).endOf('day').toDate(),
                    };
                    // console.log(payload)
                    console.log('payload', payload)
                    this.props.getAssetPurchaseReport(payload)
                } else {
                    message.error("Period From couldn't come earlier than Period To!");
                }
            }
        });
    };

    handleAssetSelect = (val) => {
        if (val)
            this.setState({
                selectedAsset: val
            })
    }

    downloadReport = (assetReport) => {
        if (!assetReport || !assetReport.length) return
        try {
            let docs = [];
            assetReport.map(data => docs = docs.concat(data))
            // console.log(docs)
            // const uniqueMeters = [...new Set(docs.flatMap(obj => obj.meterNames))];
            // console.log(uniqueMeters)
            let fields = [
                { label: 'Asset Code', value: 'assetCode' },
                { label: 'Owner Code', value: 'ownerCode' },
                { label: 'Asset Model', value: 'assetModel' },
                { label: 'Location', value: 'location' },
                { label: 'Sub Location', value: 'subLocation' },
                { label: 'PI Number', value: 'piNumber' },
                { label: 'Purchase Date', value: (row) => row.purchaseDate && moment(row.purchaseDate).format('DD-MM-YYYY') },
                { label: 'Purchase Vendor', value: 'purchaseVendor' },
                { label: 'Invoice Number', value: 'invoiceNumber' },
                { label: 'Purchase Value', value: 'purchaseValue' },
            ];
            const documentCols = [];
            const maxDocuments = Math.max(...docs.map(record => record.documents ? record.documents.length : 0))
            for (let i = 0; i < maxDocuments; i++) {
                documentCols.push({
                    label: `Document ${i + 1}`,
                    value: (row) => (row.documents && row.documents[i]) ? row.documents[i].file.path : ''
                })
            }

            fields = fields.concat(documentCols)
            // Convert data to CSV format
            const csv = json2csv.parse(docs, { fields });

            // Create zip file
            const zip = new JSZip()

            // Add CSV to zip
            zip.file('asset-purchase-report.csv', csv)

            // Create documents folder in zip
            const docsFolder = zip.folder('documents')

            const setOfDocuments = new Map()

            // Collect all document download promises
            const documentPromises = docs
                .filter(doc => doc.documents && doc.documents.length)
                .flatMap((doc) =>
                    doc.documents.map(async (document, index) => {
                        if (!document.file || !document.file.path) return

                        const fileName = doc.piNumber + '-' + (index + 1) + '.' + document.file.name.split('.').pop()
                        const docPath = document.file.path
                        // console.log('Document - ', setOfDocuments)
                        // check if document is already in set
                        if (setOfDocuments.has(docPath)) {
                            const cachedBlob = setOfDocuments.get(docPath)
                            docsFolder.file(fileName, cachedBlob)
                            return
                        } else {

                            try {
                                const response = await fetch(docPath)
                                if (!response.ok) throw new Error(`Failed to fetch ${docPath}`)

                                const blob = await response.blob()
                                setOfDocuments.set(docPath, blob)
                                docsFolder.file(fileName, blob)
                            } catch (error) {
                                console.error(`Error downloading document: ${docPath}`, error)
                            }
                        }
                    })
                )

            // Wait for all documents to be downloaded then generate zip
            Promise.all(documentPromises)
                .then(() => {
                    return zip.generateAsync({ type: 'blob' })
                })
                .then(zipBlob => {
                    saveAs(zipBlob, `asset-purchase-report-${new Date().getTime()}.zip`)
                })
                .catch(error => {
                    console.error('Error generating report:', error)
                    message.error('Failed to generate report. Please try again.')
                })

        } catch (error) {
            console.error('Error preparing report:', error)
            message.error('Failed to prepare report. Please try again.')
        }
    }


    processColumn = (assetPurchaseReportData) => {
        let fixedCols = [
            {
                title: 'Asset Code', dataIndex: 'assetCode', key: 'assetCode', width: '120px',
                render: (assetCode) => <div>{assetCode}</div>
            },
            {
                title: 'Owner Code', dataIndex: 'ownerCode', key: 'ownerCode', width: '100px',
                render: (ownerCode) => <div>{ownerCode}</div>
            },
            {
                title: 'Asset Model', dataIndex: 'assetModel', key: 'assetModel', width: '100px',
                render: (assetModel) => <div>{assetModel}</div>
            },
            {
                title: 'Location', dataIndex: 'location', key: 'location', width: '100px',
                render: (location) => <div>{location}</div>
            },
            {
                title: 'Sub Location', dataIndex: 'subLocation', key: 'subLocation', width: '100px',
                render: (subLocation) => <div>{subLocation}</div>
            },
            {
                title: 'PI Number', dataIndex: 'piNumber', key: 'piNumber', width: '100px',
                render: (piNumber, record) => <div>{piNumber && <Link target="_blank" to={`/purchase-order/view/${record._id}`}>{piNumber}</Link>}</div>
            },
            {
                title: 'Purchase Date',
                dataIndex: 'purchaseDate',
                key: 'purchaseDate',
                render: (purchaseDate) => <div>{purchaseDate && moment(purchaseDate).format('DD-MM-YYYY')}</div>
            },
            {
                title: 'Purchase Vendor',
                dataIndex: 'purchaseVendor',
                key: 'purchaseVendor',
                render: (purchaseVendor) => <div>{purchaseVendor}</div>
            },
            {
                title: 'Invoice Number',
                dataIndex: 'invoiceNumber',
                key: 'invoiceNumber',
                render: (invoiceNumber) => <div>{invoiceNumber}</div>
            },
            {
                title: 'Purchase Value',
                dataIndex: 'purchaseValue',
                key: 'purchaseValue',
                render: (purchaseValue) => <div>{purchaseValue}</div>
            },

        ];

        // Dynamically generate document columns based on max documents length
        const maxDocuments = Math.max(...assetPurchaseReportData.map(record => record.documents ? record.documents.length : 0))

        let documentColumns = []
        for (let i = 0; i < maxDocuments; i++) {
            documentColumns.push({
                title: `Document ${i + 1}`,
                dataIndex: `document${i + 1}`,
                key: `document${i + 1}`,
                render: (text, record) => {
                    if (record.documents && record.documents[i]) {
                        return <div>{(record.documents[i] && record.documents[i].file) ?
                            <a href={record.documents[i].file.path} target="_blank" rel="noopener noreferrer">{record.piNumber}-{i + 1}.{record.documents[i].file.name.split('.').pop()}</a>
                            : '-'}</div>
                    }
                    return <div>-</div>
                }
            })
        }

        fixedCols = fixedCols.concat(documentColumns)
        // console.log(fixedCols)
        return fixedCols;

    }


    render() {

        const { getFieldDecorator, setFieldsValue } = this.props.form;
        const { loading, assetPurchaseReportData, assetFilters } = this.props;

        const { assetTypes, assetSubTypes, assetModels, assetCategories } = assetFilters || {};

        // console.log(mileage_report_data)

        const assetReportData = [...assetPurchaseReportData]

        return (

            <div>
                <Spin spinning={loading}>
                    <Card
                        className={`gx-card-metrics`}
                        title={`Asset Purchase Report`}
                    >
                        <Form
                            onSubmit={this.handleSubmit}
                            className="ant-advanced-search-form"
                            layout="inline"
                            labelAlign="left"
                        >
                            <Row gutter={8}>
                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item key={'location'} label={'Location'} style={{ width: '100%' }}>
                                        {getFieldDecorator(`location`, {
                                            rules: [{ required: true, message: `Location is required!` }],
                                        })(<Select
                                            showSearch
                                            showArrow
                                            filterOption={(input, option) =>
                                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                            }
                                            placeholder={`Select Location`}
                                        >
                                            <Select.Option key={'AllLocation'}
                                                value={'all'}>All</Select.Option>
                                            {(this.props.authUser && this.props.authUser.locations || []).map(item =>
                                                <Select.Option key={item._id}
                                                    value={item._id}>{item.name}</Select.Option>)}

                                        </Select>)
                                        }
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item key={'subLocation'} label={'Sub Location'} style={{ width: '100%' }}>
                                        {getFieldDecorator(`subLocation`, {
                                            rules: [{ required: true, message: `Sub Location is required!` }],
                                        })(<Select
                                            showSearch
                                            showArrow
                                            filterOption={(input, option) =>
                                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                            }
                                            placeholder={`Select Sub Location`}
                                        >
                                            <Select.Option key={'AllSubLocation'}
                                                value={'all'}>All</Select.Option>
                                            {(this.props.authUser && this.props.authUser.clients || []).map(item =>
                                                <Select.Option key={item._id}
                                                    value={item._id}>{item.name}</Select.Option>)}

                                        </Select>)
                                        }
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item
                                        key={"periodFromTo"}
                                        label={"Select Period"}
                                        style={{ width: "100%" }}
                                    >
                                        {getFieldDecorator(`periodFromTo`, {
                                            rules: [
                                                { required: true, message: `Period From To is required!` }
                                            ],
                                            initialValue: null
                                        })(<RangePicker style={{ width: "100%" }} />)}
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item key={'asset'} label={'Asset'} style={{ width: '100%' }}>
                                        {getFieldDecorator(`asset`, {
                                            rules: [{ required: false, message: `Asset is required!` }],
                                        })(<AssetSearch
                                            styleName="gx-lt-icon-search-bar-lg"
                                            placeholder="Search Assets..."
                                            onChange={this.props.searchGlobalAssetData}
                                            assetData={
                                                this.props.assetData && this.props.assetData.filter((ast) => ast.assetModel)
                                            } // only assets with assetModel
                                            onSelect={this.handleAssetSelect}
                                            authUser={this.props.authUser}
                                            loading={this.props.assetSearchLoading}
                                        />)}
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item
                                        key={"assetType"}
                                        label={"Asset Type"}
                                        style={{ width: "100%" }}
                                    >
                                        {getFieldDecorator(`assetType`)(
                                            <Select
                                                showSearch
                                                showArrow
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                placeholder={`Select Asset Type`}
                                            >
                                                <Select.Option key={'AllType'}
                                                    value={'all'}>All</Select.Option>
                                                {(assetTypes || []).map(item =>
                                                    <Select.Option key={item._id}
                                                        value={item._id}>{item.name}</Select.Option>)}

                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item
                                        key={"assetSubType"}
                                        label={"Asset Sub Type"}
                                        style={{ width: "100%" }}
                                    >
                                        {getFieldDecorator(`assetSubType`)(
                                            <Select
                                                showSearch
                                                showArrow
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                placeholder={`Select Asset Sub Type`}
                                            >
                                                <Select.Option key={'AllSubType'}
                                                    value={'all'}>All</Select.Option>
                                                {(assetSubTypes || []).map(item =>
                                                    <Select.Option key={item._id}
                                                        value={item._id}>{item.name}</Select.Option>)}

                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item
                                        key={"assetModel"}
                                        label={"Asset Model"}
                                        style={{ width: "100%" }}
                                    >
                                        {getFieldDecorator(`assetModel`)(
                                            <Select
                                                showSearch
                                                showArrow
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                placeholder={`Select Asset Model`}
                                            >
                                                <Select.Option key={'AllModel'}
                                                    value={'all'}>All</Select.Option>
                                                {(assetModels || []).map(item =>
                                                    <Select.Option key={item._id}
                                                        value={item._id}>{item.name}</Select.Option>)}

                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item style={{ marginTop: '25px' }}>
                                        <span style={{ display: 'flex', flexDirection: 'row' }}>
                                            <Button type="primary" htmlType="submit" loading={loading}>
                                                Generate Report
                                            </Button>
                                            <Button disabled={!assetReportData || !assetReportData.length}
                                                type="default" htmlType="button" loading={loading} icon={'download'}
                                                onClick={() => this.downloadReport(assetReportData)}>
                                                Download
                                            </Button>
                                        </span>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>

                        {(assetReportData && assetReportData.length) ?
                            <Table dataSource={assetReportData} columns={this.processColumn(assetReportData)} pagination={false}
                                rowKey={'_id'}
                                scroll={{ x: true }} bordered />

                            : loading ? <Skeleton active /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                    </Card>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = ({ auth, purchaseOrder, commonData }) => {
    return {
        authUser: auth.authUser,
        loading: commonData.loading,
        assetPurchaseReportData: purchaseOrder.assetPurchaseReportData,
        assetFilters: commonData.assetFilters,
        assetData: commonData.assetSearchData,
        assetSearchLoading: commonData.assetSearchLoading,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        getAssetPurchaseReport,
        fetchAssetFiltersData,
        searchGlobalAssetData
    };
}

const AssetPurchaseReport = Form.create({ name: 'asset-purchase-report' })(AssetPurchaseReportComponent);
export default connect(mapStateToProps, mapDispatchToProps())(AssetPurchaseReport);
